module.exports = __webpack_public_path__ + "img/MySQL.07c28adf.png";